import styled from "styled-components";

export const SelectionToolbarOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0 16px 24px;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 10000;

  @media (max-width: 640px) {
    padding: 0 12px 16px;
  }
`;

export const SelectionToolbarCard = styled.div`
  pointer-events: auto;
  box-sizing: border-box;
  width: fit-content;
  min-width: min(400px, 100%);
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: nowrap;
  padding: 8px 16px;
  background: var(--color-contrast-white, #ffffff);
  border: none;
  border-radius: 0;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);

  @media (max-width: 640px) {
    padding: 8px 12px;
  }
`;

export const SelectionToolbarSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 0 1 auto;
`;

export const SelectionToolbarIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--color-neutral-900, #0e0e0e);
`;

export const SelectionToolbarSummaryText = styled.p`
  margin: 0;
  min-width: 0;
  color: var(--color-neutral-900, #0e0e0e);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 640px) {
    font-size: 16px;
    white-space: normal;
  }
`;

export const SelectionToolbarActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
`;

export const SelectionToolbarDeleteButton = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 105px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--color-action-default, #2c589b);
  border-radius: 2px;
  background: var(--color-contrast-white, #ffffff);
  color: var(--color-action-default, #2c589b);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: rgba(44, 88, 155, 0.04);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const SelectionToolbarCloseButton = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 0;
  color: var(--color-neutral-900, #0e0e0e);
  cursor: pointer;

  &:hover {
    background: rgba(14, 14, 14, 0.06);
  }

  svg {
    display: block;
  }
`;
